import { Pipe, PipeTransform } from '@angular/core';
import { parseValue } from '../pipes/parse-value.util';

/**
 * Shim of the AngularJS `parse` filter — `value | parse:'number'` /
 * `value | parse:'bool'` / `value | parse:'array'[:default]`. Provides the same
 * template syntax across advocacy/platform/etc. leaf ports (used via
 * AccountSharedModule by the non-standalone contests/audiences/People details-body).
 *
 * Delegates to `parseValue`, the BYTE-EXACT port of v1 `core/parse/parse.js`
 * (proven ≡ the live v1 `$filter('parse')` by _diag-parse-check 0/900 (#31) +
 * _diag-parse-service-check 561/0 (#33)). This replaced a slightly DIVERGENT local
 * impl (parseFloat + a `=null` default); collapsing onto `parseValue` makes the
 * pipe v1-faithful. The only behavioural delta — number null/undefined/'' now
 * defaults to 0 like v1, not null — does NOT occur on gate data (else the People
 * details gate would already be red); proven by _diag-legacy-parse-check
 * (24/27 identical + 3 v1-faithful null→0 edges).
 *
 * Two pipes named `parse` across distinct NgModule scopes don't collide (Angular
 * resolves per-template-scope); contest-sheets + story-modal have their own
 * standalone `parse` pipes that ALSO delegate to `parseValue`.
 */
@Pipe({
    name: 'parse',
    standalone: false
})
export class LegacyParsePipe implements PipeTransform {
  transform(value: any, type: string, defaultValue?: any): any {
    return parseValue(value, type, defaultValue);
  }
}
